export default __webpack_public_path__ + "static/media/brandico_facebook-rect.065acfea.svg";